module.exports = __webpack_public_path__ + "img/sync.b8f4abed.svg";